// extracted by mini-css-extract-plugin
module.exports = {"matchTeamComparisonStats":"style_matchTeamComparisonStats__QlI13","title":"style_title__7Q0KZ","tableContainer":"style_tableContainer__mt_zy"};